<div class="quick-actions">
</div>
<mat-dialog-content>
  <mat-table
    [dataSource]="items"
    matSort
    matSortDisableClear
    [matSortActive]="sort"
    style="max-height: 525px"
    [matSortDirection]="sortDirection"
    (matSortChange)="onSortChange($event)"
  >
    <ng-container matColumnDef="fullName">
      <mat-header-cell *matHeaderCellDef>{{ 'common.name' | t }}</mat-header-cell>
      <mat-cell *matCellDef="let user"> {{ user.firstName }} {{ user.lastName }} </mat-cell>
    </ng-container>
    <ng-container matColumnDef="email">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'common.email' | t }}</mat-header-cell>
      <mat-cell *matCellDef="let user">
        {{ user.email }}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="lastActive">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'common.lastActive' | t }}</mat-header-cell>
      <mat-cell *matCellDef="let user">
        <sn-user-last-active dateFormat="mediumDate" [user]="user"></sn-user-last-active>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="canView">
      <mat-header-cell *matHeaderCellDef>{{ 'common.canView' | t }}</mat-header-cell>
      <mat-cell *matCellDef="let user">
        <mat-checkbox
          [checked]="user.canView"
          [aria-label]="'Toggle view ' + user.email"
          (change)="controlActions($event, user.id, 'view')"
        ></mat-checkbox>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="canEdit">
      <mat-header-cell *matHeaderCellDef>{{ 'common.canEdit' | t }}</mat-header-cell>
      <mat-cell *matCellDef="let user">
        <mat-checkbox
          [checked]="user.canEdit"
          [aria-label]="'Toggle edit ' + user.email"
          (change)="controlActions($event, user.id, 'edit')"
        ></mat-checkbox>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="isAdmin">
      <mat-header-cell *matHeaderCellDef>{{ 'common.admin' | t }}</mat-header-cell>
      <mat-cell *matCellDef="let user">
        <mat-checkbox
          [checked]="user.isAdmin"
          [aria-label]="'Toggle admin ' + user.email"
          (change)="controlActions($event, user.id, 'admin')"
        ></mat-checkbox>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="columns; sticky: true"></mat-header-row>
    <mat-row matRipple *matRowDef="let user; columns: columns"> </mat-row>
  </mat-table>
</mat-dialog-content>
<mat-dialog-actions>
  <sn-flat-button color="danger" mat-dialog-close class="cancelButton">{{ 'common.cancel' | t }}</sn-flat-button>
  <sn-flat-button color="success" (click)="save()" class="saveButton">{{ 'common.save' | t }}</sn-flat-button>
</mat-dialog-actions>
